export default "__VITE_ASSET__BKyirhJ$__"